import { type PropsWithChildren } from "react";

export const Header = ({ children }: Readonly<PropsWithChildren>) => (
  <header data-testid="circle-ai-shell-canvas-header" className="shrink-0">
    {children}
  </header>
);

Header.displayName = "CircleAIAppShell.Layout.Canvas.Header";
